// extracted by mini-css-extract-plugin
export default {"root":"IconCouples_root__hU15n"};